export const isAnnotator = (rating: number): boolean => {
    if (rating < 4) {
        return true
    } else {
        return false
    }
}